import React from "react";

const WarningIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M21.7524318,4.85290633 L36.7032227,32.0361625 C37.2355355,33.0040039 36.8824698,34.2201191 35.9146284,34.7524318 C35.6193384,34.9148413 35.2877968,35 34.9507909,35 L5.04920911,35 C3.94463961,35 3.04920911,34.1045695 3.04920911,33 C3.04920911,32.6629941 3.13436781,32.3314525 3.29677729,32.0361625 L18.2475682,4.85290633 C18.7798809,3.88506497 19.9959961,3.53199926 20.9638375,4.06431202 C21.2961569,4.2470877 21.5696561,4.5205869 21.7524318,4.85290633 Z M18.3333322,28.3333318 L21.6666654,28.3333318 L21.6666654,31.666665 L18.3333322,31.666665 L18.3333322,28.3333318 Z M18.3333322,13.333332 L21.6666654,13.333332 L21.6666654,24.9999987 L18.3333322,24.9999987 L18.3333322,13.333332 Z"
        id="path-1"
      />
    </defs>
    <g id="Alert/Mixin/Icon/Warning" fill="none" fillRule="evenodd">
      <g id="Icon/Alert/Warning">
        <mask id="mask-2" fill="#fff">
          <use xlinkHref="#path-1" />
        </mask>
        <use id="Fill-2" fill="#000" xlinkHref="#path-1" />
        <g id="Colors/Yellow-Dark" mask="url(#mask-2)" fill="#ED9620">
          <rect id="foo️" width="40" height="40" />
        </g>
      </g>
    </g>
  </svg>
);

export default WarningIcon;
